import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from './Icon';

export interface OnboardingProgressIndicatorProps {
  numberOfCompleted: number;
  total: number;
}

export const OnboardingProgressIndicator: React.FC<OnboardingProgressIndicatorProps> = ({
  numberOfCompleted,
  total,
}) => {
  const __ = useTranslation().t;

  const CurrentIcon = () => (
    <div className="oejr-onboarding-progress-indicator-step oejr-step-current" />
  );
  const DoneIcon = () => (
    <div className="oejr-onboarding-progress-indicator-step oejr-step-done">
      <Icon name="check" />
    </div>
  );
  const PendingIcon = () => (
    <div className="oejr-onboarding-progress-indicator-step oejr-step-pending" />
  );

  const icons = [];
  for (let i = 1; i <= total; i++) {
    icons.push(
      i <= numberOfCompleted ? (
        <DoneIcon key={i} />
      ) : i === numberOfCompleted + 1 ? (
        <CurrentIcon key={i} />
      ) : (
        <PendingIcon key={i} />
      ),
    );
  }

  return (
    <div className="oejr-onboarding-progress-indicator">
      {icons.map((icon, key) => icon)}
      <span>
        {__('stepOf', {
          1: numberOfCompleted < total ? numberOfCompleted + 1 : numberOfCompleted,
          2: total,
        })}
      </span>
    </div>
  );
};
